import { render, staticRenderFns } from "./AssessmentDetails.vue?vue&type=template&id=11321a82&scoped=true&"
import script from "./AssessmentDetails.vue?vue&type=script&lang=ts&"
export * from "./AssessmentDetails.vue?vue&type=script&lang=ts&"
import style0 from "./AssessmentDetails.vue?vue&type=style&index=0&id=11321a82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11321a82",
  null
  
)

export default component.exports